import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import {
	getSelectedTenants,
	prefetchTenantsLogSources,
} from '@/features/air/multi-tenant/queries'

import { TableFullSkeleton } from '@/shared/data-table/components/table-skeleton'

const PoliciesTable = lazy(
	() => import('@/features/air/multi-tenant/components/policies-table'),
)

export const Route = createFileRoute(
	'/_dashboard/multi-tenant/_layout/policies',
)({
	// `t`: the catalog prefetch is keyed by the current tenant (GOTCHAS).
	loaderDeps: ({ search }) => ({ t: search.t, tenants: search.tenants }),
	// The Log Source options: the selected tenants' connectors.
	loader: ({ deps, context: { queryClient } }) => {
		prefetchTenantsLogSources(
			queryClient,
			getSelectedTenants(queryClient, deps.tenants),
		)
	},
	component: PoliciesTab,
	pendingComponent: RouteSkeleton,
})

function PoliciesTab() {
	return (
		<Suspense fallback={<TableFullSkeleton rows={10} />}>
			<PoliciesTable />
		</Suspense>
	)
}

function RouteSkeleton() {
	return <TableFullSkeleton rows={10} />
}
